import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import { intelligenceV2 } from '@modules/aawz-intelligence-v2/constants/URL'

const SEM_MATERIAL = 422

/**
 * Rascunho da entrega de um serviço, em `.docx`.
 *
 * Com `idConversa` o rascunho é PERSONALIZADO — as partes vêm do catálogo e o
 * conteúdo vem do que foi diagnosticado e respondido naquela conversa. Sem ele,
 * o backend devolve o documento estrutural (spec-001).
 *
 * O envelope é o base64 padrão da casa, e é por isso que não há
 * `responseType: 'blob'` nem configuração especial de axios.
 */
class APIRascunhoEntrega extends APITemplate {
  /**
   * @param {String} codigo Código do serviço no catálogo (`9.1`, `TEC-G3`).
   * @param {String} idConversa Conversa de origem; sem ela sai o estrutural.
   * @returns {Promise<Object|null>} Três desfechos distintos, porque a UI reage
   *   a cada um de um jeito:
   *   - `{ arquivo: {base64, name, extension} }` — baixa;
   *   - `{ faltando: [...], message }` — a conversa não tem material; o cartão
   *     mostra o que responder, em vez de "erro ao gerar";
   *   - `{ message }` — não deu, e `message` é o motivo do backend (serviço sem
   *     desenho publicado, sessão expirada, rede fora). Vem vazio quando o
   *     backend não disse nada, e aí quem chama escolhe a frase.
   *
   *   `null` só quando não há código para pedir — a requisição nem sai.
   *
   *   O `status` NÃO é repassado de propósito: quem chama decide o que dizer ao
   *   gestor, não como o backend numerou a falha.
   */
  async fetch(codigo, idConversa) {
    if (!codigo) return null
    const r = await con.get(intelligenceV2.rascunhoEntrega(codigo, idConversa))
    if (r && r.status === 200 && r.value) return { arquivo: r.value }
    if (r && r.status === SEM_MATERIAL) {
      return {
        faltando: (r.value && r.value.faltando) || [],
        message: r.message || '',
      }
    }
    return { message: (r && r.message) || '' }
  }
}

export const apiRascunhoEntrega = new APIRascunhoEntrega()
